import { Injectable } from '@angular/core';
import { RsTitleStrategy } from '@rs-shared-lib/strategies/rs-title-strategy.service';
import { BRAND_NAMES } from '@rs-shared-lib/constants/brand-names';

@Injectable({ providedIn: 'root' })
export class OrdAdminTitleStrategy extends RsTitleStrategy {
  protected appName = BRAND_NAMES['ORD_ADMIN'];
}
